import { render, staticRenderFns } from "./estudiantes.vue?vue&type=template&id=cf569b8a"
import script from "./estudiantes.vue?vue&type=script&lang=js"
export * from "./estudiantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports